// @flow
import { useContext } from 'react';
import { RATE_CARD_BACKEND_NAME } from '@src/constants';

import { EstimateContext } from '../contexts/EstimateContext';

export const useEstimateRateCardVersion = () => {
  const estimate = useContext(EstimateContext);
  const rateCardVersion = estimate?.inputs?.[RATE_CARD_BACKEND_NAME] ?? null;

  if (rateCardVersion == null) {
    throw new Error('Rate Card Version not found in Estimate Inputs, please check!');
  }

  return rateCardVersion;
};
